import { useCallback, useEffect, useRef } from "react";
import {
  extractValidMapPositions,
  fitMapToVisibleMarkers,
  getVisibleUnitsSignature
} from "app/data/helpers/mapHelpers";

const useFitMapToVisibleUnits = (
  map: google.maps.Map | undefined,
  items: unknown[],
  enabled = true,
  resetKey?: string | null,
  /** When set, skip auto-fit so focusing a single unit is not undone. */
  selectedObjectId?: string | null
) => {
  const lastFittedSignatureRef = useRef<string | null>(null);

  useEffect(() => {
    lastFittedSignatureRef.current = null;
  }, [map, resetKey]);

  const fitToVisibleUnits = useCallback(
    (force = false) => {
      if (!enabled || !map || selectedObjectId) return;

      const signature = getVisibleUnitsSignature(items);
      if (!force && lastFittedSignatureRef.current === signature) return;

      fitMapToVisibleMarkers(map, extractValidMapPositions(items));
      lastFittedSignatureRef.current = signature;
    },
    [enabled, items, map, selectedObjectId]
  );

  useEffect(() => {
    fitToVisibleUnits(false);
  }, [fitToVisibleUnits]);

  return { fitToVisibleUnits };
};

export default useFitMapToVisibleUnits;
